import React from 'react';
import { Typography } from '@material-ui/core';
import { OnlineOrderingStore } from 'kiolyn-api';
import { isNull } from 'lodash';
import { useOrdering } from '../../stores/OrderingStore';
import Image from 'material-ui-image';
import { Variant } from '@material-ui/core/styles/createTypography';

interface Props {
  textClassName?: string;
  variant: Variant;
  className?: string;
  disableLogo?: boolean;
}

export default ({ className, variant, textClassName, disableLogo }: Props) => {
  const orderingStore = useOrdering();
  const store = orderingStore.store as OnlineOrderingStore;

  return (
    <div className={className}>
      {!disableLogo &&
      store.info_page_settings?.show_store_logo &&
      store.image_url ? (
        <Image
          src={store.image_url}
          style={{
            paddingTop: 0,
            background: 'none'
          }}
          imageStyle={{
            maxHeight: '150px',
            width: 'auto',
            position: 'inherit'
          }}
        />
      ) : null}
      <Typography variant={variant} className={textClassName}>
        {isNull(orderingStore.store)
          ? 'Store not found'
          : orderingStore.store.name}
      </Typography>
    </div>
  );
};
